// extracted by mini-css-extract-plugin
export var deliveryRow = "_nw-a";
export var fixedHeight = "_nw-4";
export var freightLogo = "_nw-9";
export var fullWidth = "_nw-3";
export var priceColumn = "_nw-5";
export var radioSelected = "_nw-7";
export var radioUnselected = "_nw-6";
export var selectedOption = "_nw-2";
export var selectedOptionContainer = "_nw-1";
export var selection = "_nw-0";
export var tallSkeletonText = "_nw-8";